import * as React from 'react'

function SvgFunPlus(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M18 11h-5V6a1 1 0 00-2 0v5H6a1 1 0 000 2h5v5a1 1 0 002 0v-5h5a1 1 0 000-2" />
    </svg>
  )
}

export default SvgFunPlus
